import { vuexfireMutations, firebaseAction } from 'vuexfire'
import * as MR from '@/libs/maybe-ramda'
import * as types from '../mutation-types'
import { stateManager } from '../helper'

const sm = stateManager({
  book: null,
  memo: null
})

export default {
  state: sm.get(),
  mutations: {
    [types.META_RESET] (state) {
      sm.reset(state)
    },
    ...vuexfireMutations
  },
  actions: {
    setMetaRef: firebaseAction(({ bindFirebaseRef }, { ref, name }) => {
      return new Promise((resolve, reject) => {
        bindFirebaseRef(name, ref).then(resolve).catch(reject)
      })
    }),
    clearMetaRef: firebaseAction(({ unbindFirebaseRef }, { ref, name }) => {
      unbindFirebaseRef(name)
    })
  },
  getters: {
    bookCount (state) {
      return MR.of(state.book).chain(MR.prop('count')).getOrElse(0)
    },
    memoCount (state) {
      return MR.of(state.memo).chain(MR.prop('count')).getOrElse(0)
    }
  }
}
